import type { BeforeInstallPromptEvent } from "kz-ui-sdk";
import { useSyncExternalStore } from "react";

let capturedPrompt: BeforeInstallPromptEvent | null = null;
const subscribers = new Set<() => void>();

export const setCapturedPrompt = (prompt: BeforeInstallPromptEvent | null) => {
  capturedPrompt = prompt;
  subscribers.forEach((notify) => notify());
};

const subscribe = (notify: () => void) => {
  subscribers.add(notify);
  return () => {
    subscribers.delete(notify);
  };
};

export const useCapturedInstallPrompt = () => useSyncExternalStore(subscribe, () => capturedPrompt);
